import { useMutation } from "@tanstack/react-query";
import { message } from "antd";

import { DishIssueStatus } from "@fitness-app/data-models/entities/DishIssue";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { supabase } from "~/store/initializeStore";

type ReportDishIssuePayload =
  | {
      dishId: string;
      reason: string;
      ownerId: string | null;
      id?: string;
    }
  | {
      reason: string;
      ingredientId: string;
      ownerId: string | null;
      id?: string;
    };

export const useReportDishIssue = (showToast = true) => {
  const { userId } = useUserRole();

  const mutation = useMutation({
    async mutationFn(payload: ReportDishIssuePayload) {
      const { error } = await supabase.from("dish_issue").insert({
        ...payload,
        status: DishIssueStatus.Reported,
        reportedBy: userId,
      });

      if (error) {
        throw new Error(error.message);
      }
    },
    onSuccess: () => {
      if (showToast) {
        message.success("Błąd został zgłoszony");
      }
    },
    onError: (error: Error) => {
      message.error(error.message);
    },
  });

  return {
    reportIssue: mutation.mutateAsync,
    isReporting: mutation.isLoading,
  };
};
